import { makeStyles } from '@material-ui/core'
// import whatsBackground from '../../assets/wa-background.png'
// import whatsBackgroundDark from '../../assets/wa-background-dark.png'

export const useStyles = makeStyles(theme => ({
  mainContainer: {
    width: '100%',
    height: `calc(100% - 48px)`,
    padding: '4px 4px 0 4px',
    // backgroundImage:
    //   theme.mode === 'light'
    //     ? `url(${whatsBackground})`
    //     : `url(${whatsBackgroundDark})`,
    // backgroundPosition: 'center',
    // backgroundSize: 'cover',
    // backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      marginTop: '10px'
    }
  },

  contentWrapper: {
    height: '100%',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    marginRight: '65px',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0
    }
  }
}))
